export const paths = {
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgotPassword',
  LOGIN: '/login',
  PRIVACY_POLICY: '/politicaDePrivacidad',
  USERS: '/usuarios',
  NEW_USER: '/nuevo-usuario',
  BUILDING_DETAIL: '/edificios/:id',
  NEW_APARTMENT: '/nuevo-apartamento',
  NEW_DEVICE: '/nuevo-dispositivo',
  NEW_BROADCAST_GROUP: '/nuevo-grupo-de-difusion',
  BUILDINGS: '/edificios',
  NEW_BUILDING: '/nuevo-edificio',
  EVENTS: '/eventos',
  ERRORS: '/errors',
  COMMUNICATIONS: '/comunicaciones',
  NEW_COMMUNICATION: '/nueva-comunicacion',
  INVITATIONS: '/invitaciones',
  NEW_INVITATION: '/nueva-invitacion',
  USER_INVITATIONS: '/userInvitations/:id',
  USER_INVITATION_SUCCESS: '/userInvitationsSuccess',
  GUESTS: '/invitados',
  NEW_GUEST: '/nuevo-invitado',
  SERVICES: '/servicios',
  NEW_USER_EVENTS: '/userevents/:id',
  USER_EVENTS: '/eventosDeUsuario',
  REQUEST_ACCESS: '/requestAccess/:id',
  BUILDING_EVENTS: '/eventosEdificio',
  USER_EVENTS_FOR_BUILDING: '/eventosUsuario',
  NOTIFICATIONS: '/notificaciones',
  SHOPPING: '/compras',
  NEW_SHOPPING: '/nueva-compra',
  MANUAL_ACCESS: '/ingresomanual',
  BLACKLISTED: '/restringidos',
  NEW_BLACKLISTED: '/nuevo-restringido',
  CONSTRUCTION_DETAIL: '/obras/:id',
  CONSTRUCTIONS: '/obras',
  NEW_CONSTRUCTION: '/nueva-obra',
  SECURITY_USERS: '/seguridad',
  DOORBELLS: '/porteros',
  AMENITIES: '/amenities',
  NEW_AMENITY: '/nueva-amenity',
  RESERVATIONS: '/reservas',
  RESERVATIONS_REPORT: '/reservas/reporte',
  MONTHLY_REPORTS: '/reservas/reportes-mensuales',
}

export const pathMapping = {
  [paths.BUILDINGS]: [
    paths.BUILDINGS,
    paths.BUILDING_DETAIL,
    paths.NEW_BUILDING,
  ],
  [paths.EVENTS]: [paths.EVENTS],
  [paths.ERRORS]: [paths.ERRORS],
  [paths.COMMUNICATIONS]: [
    paths.COMMUNICATIONS,
    paths.NEW_COMMUNICATION,
    paths.NEW_BROADCAST_GROUP,
  ],
  [paths.INVITATIONS]: [paths.INVITATIONS, paths.NEW_INVITATION],
  [paths.GUESTS]: [paths.GUESTS, paths.NEW_GUEST],
  [paths.USER_EVENTS]: [paths.USER_EVENTS],
  [paths.BUILDING_EVENTS]: [paths.BUILDING_EVENTS],
  [paths.USER_EVENTS_FOR_BUILDING]: [paths.USER_EVENTS_FOR_BUILDING],
  [paths.NOTIFICATIONS]: [paths.NOTIFICATIONS],
  [paths.SHOPPING]: [paths.SHOPPING, paths.NEW_SHOPPING],
  [paths.USERS]: [paths.USERS, paths.NEW_USER],
  [paths.SERVICES]: [paths.SERVICES, paths.NEW_GUEST],
  [paths.MANUAL_ACCESS]: [paths.MANUAL_ACCESS],
  [paths.BLACKLISTED]: [paths.BLACKLISTED, paths.NEW_BLACKLISTED],
  [paths.CONSTRUCTIONS]: [
    paths.CONSTRUCTIONS,
    paths.NEW_CONSTRUCTION,
    paths.CONSTRUCTION_DETAIL,
  ],
  [paths.SECURITY_USERS]: [paths.SECURITY_USERS],
  [paths.DOORBELLS]: [paths.DOORBELLS],
  [paths.AMENITIES]: [paths.AMENITIES, paths.NEW_AMENITY],
  [paths.RESERVATIONS]: [paths.RESERVATIONS],
  [paths.RESERVATIONS_REPORT]: [paths.RESERVATIONS_REPORT],
  [paths.MONTHLY_REPORTS]: [paths.MONTHLY_REPORTS],
}
